class ScrollToError {
	constructor() {
		window.setTimeout(() => {
			const hasError = document.querySelector(".gform_validation_error");
			const firstError = document.querySelector(".validation_message");

			if (!hasError || !firstError) return;

			const target = firstError.closest(".gfield");
			if (target) {
				target.scrollIntoView({ behavior: "smooth", block: "center" });
				const input = target.querySelector("input, textarea, select");
				if (input) input.focus();
			}
		}, 300);
	}
}

export default ScrollToError;
